import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AppRoutingModule } from '../app-routing.module';
import { ComponentsModule } from '../components/components.module';
import { FormsModule } from '@angular/forms';
import { MaterialModule } from '../material/material.module';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { MembersModule } from '../members/members.module';
import { PermissionsHomeComponent } from './permissions-home/permissions-home.component';
import { PermissionsSectionComponent } from './permissions-section/permissions-section.component';
import { PermissionsRulesComponent } from './permissions-rules/permissions-rules.component';

@NgModule({
  declarations: [PermissionsHomeComponent, PermissionsSectionComponent, PermissionsRulesComponent],
  imports: [
    CommonModule,
    AppRoutingModule,
    ComponentsModule,
    FormsModule,
    MaterialModule,
    ScrollingModule,
    MembersModule
  ],
})
export class PermissionsModule {}
